import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { message, Modal, ModalProps } from 'antd';
import useModal from 'hooks/useModal';
import { useState } from 'react';
import { submitSupplementKnowledge } from 'services/api/supplementKnowledge';

interface Props extends ModalProps {
  externalQuestionId: string;
  question: string;
  answer: string;
}

function SaveAsItemKnowledgeModal({ externalQuestionId, question, answer, ...otherProps }: Props) {
  const { t } = useTranslate();

  const [loading, setLoading] = useState(false);

  return (
    <Modal
      closable={false}
      width={580}
      cancelText={t('暂不保存')}
      okText={t('保存知识')}
      okButtonProps={{ loading }}
      onOk={(e) => {
        setLoading(true);
        submitSupplementKnowledge({
          source: 'MERCADO_QA',
          externalQuestionId,
        })
          .then(() => {
            message.success(t('phrase.保存成功'));
            otherProps.onCancel?.(e);
          })
          .catch(() => {
            message.error(t('phrase.保存失败，请稍后再试'));
          })
          .finally(() => {
            setLoading(false);
          });
      }}
      {...otherProps}
    >
      <Container>
        <h3>{t('保存为商品知识？')}</h3>
        <div>
          {t('你修改后的回答可以保存到商品知识， 帮助 AI 后续为类似问题推荐更准确的答案。')}
        </div>
        <section>
          <dl>
            <dt>{t('问题')}：</dt>
            <dd>{question}</dd>
          </dl>
          <dl>
            <dt>{t('答案')}：</dt>
            <dd>{answer}</dd>
          </dl>
        </section>
      </Container>
    </Modal>
  );
}

export function useSaveAsItemKnowledge() {
  const { visible, show, hide, meta } = useModal<Props>();

  const modal = meta && <SaveAsItemKnowledgeModal {...meta} visible={visible} />;

  return [modal, show, hide] as const;
}

const Container = styled.div`
  > div {
    margin-bottom: 18px;
    color: #515359;
  }
  > section {
    padding: 16px;
    background: #f7f9fa;
    > dl {
      display: flex;
      margin: 0;
      > dt {
        white-space: nowrap;
      }
    }
  }
`;

export default SaveAsItemKnowledgeModal;
